import React, { useEffect, useState } from 'react'

import STextWithTooltip from '../../opinionless/STextWithTooltip'
import SFlex from '../../opinionless/SFlex'
import { StyledCheckbox } from './styles'

import FLabel from '../FLabel'
import { defaultMargin } from '../constants'
import { useSTheme } from 'styles/theme'

interface Props {
    name: string
    value: string
    onChange?: (e) => void
    isChecked?: boolean
    text: string
    tooltip?: string
    tooltipImage?: string
    size?: string
    defaultChecked?: boolean
    id?: string
    color?: string
    errors?: unknown[]
    label?: string
}

const FCheckBox = React.forwardRef((props: Props, ref) => {
    const [isChecked, setIsChecked] = useState(props.isChecked)
    const theme = useSTheme()
    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.body || theme.fontsV2.default

    const toggleChecked = () => {
        setIsChecked(!isChecked)
        if (props.onChange) {
            props.onChange(!isChecked)
        }
    }

    useEffect(() => {
        setIsChecked(props.isChecked)
    }, [props.isChecked])

    return (
        <React.Fragment>
            {props.label && <FLabel for={props.id}>{props.label as any}</FLabel>}
            <SFlex flexDirection={'row'} sx={{ position: 'relative', alignItems: 'center', marginTop: defaultMargin }}>
                <SFlex minWidth={'auto'} onClick={() => toggleChecked()}>
                    <StyledCheckbox
                        id={props.id}
                        checked={isChecked}
                        size={props.size}
                        defaultChecked={props.defaultChecked}
                        name={props.name}
                        value={props.value}
                        mr={3}
                        sx={{
                            '&:hover': {
                                cursor: 'pointer',
                            },
                        }}
                        color={props.color}
                    />
                </SFlex>
                <STextWithTooltip
                    tooltip={props.tooltip}
                    text={props.text}
                    textStyle={{ fontFamily: fontFamily }}
                    listStyle={'none'}
                    tooltipImage={props.tooltipImage}
                />
            </SFlex>
            {/*<ConditionalRender if={errors?.[props.name]}>*/}
            {/*    <SInputError forElementId={props.id}>{t(errors?.[props.name]?.message)}</SInputError>*/}
            {/*</ConditionalRender>*/}
        </React.Fragment>
    )
})

FCheckBox.displayName = 'FCheckBox'

export default FCheckBox
